import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import MainLayout from '../../layouts/MainLayout';
import ArTemplatesPage from '../ArTemplatesPage/ArTemplatesPage';
import ArEmailPage from '../ArEmailPage/ArEmailPage';
import PlantillasSms from './PlantillasSms';
import HelpTip from '../../components/HelpTip';

/**
 * «Plantillas»: lo que DICE cada mensaje de la empresa, por canal. Cuándo sale y
 * en qué orden está en «Configuración» (`/ar-arranque`).
 *
 * Cada pestaña es la pantalla de su canal tal cual, porque cada canal tiene su
 * trámite: WhatsApp lo revisa ClaimUp y lo aprueba Meta; correo y SMS salen como
 * los escribe la empresa. `/ar-templates` y `/ar-email` siguen llevando aquí.
 */
export const CANALES = [
  ['whatsapp', 'WhatsApp'],
  ['correo', 'Correo'],
  ['sms', 'SMS'],
];

const PlantillasPage = () => {
  const [params, setParams] = useSearchParams();
  const canal = CANALES.some(([c]) => c === params.get('canal')) ? params.get('canal') : 'whatsapp';

  return (
    <MainLayout>
      <div className='max-w-7xl mx-auto space-y-4'>
        <div className='flex items-center gap-2'>
          <DocumentTextIcon className='w-7 h-7 text-blue-600' />
          <h1 className='text-2xl font-semibold text-slate-900'>Plantillas</h1>
          <HelpTip title='¿Por qué WhatsApp necesita plantillas?'>
            WhatsApp solo deja escribir libremente en las 24 horas siguientes a cada mensaje del deudor. Para
            escribirle primero, o pasado ese plazo, hace falta una plantilla que Meta haya aprobado antes. Aprobarla
            suele llevar de unas horas a un par de días.
          </HelpTip>
        </div>
        <p className='text-sm text-slate-600'>
          Lo que dice cada mensaje a tus deudores. Cuándo se manda y en qué orden se decide en Configuración.
        </p>

        <div role='tablist' aria-label='Canal' className='flex gap-1 border-b border-slate-200'>
          {CANALES.map(([c, label]) => (
            <button
              key={c}
              type='button'
              role='tab'
              aria-selected={canal === c}
              onClick={() => setParams({ canal: c }, { replace: true })}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
                canal === c ? 'border-blue-600 text-blue-700' : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        <div role='tabpanel'>
          {canal === 'whatsapp' && <ArTemplatesPage />}
          {canal === 'correo' && <ArEmailPage />}
          {canal === 'sms' && <PlantillasSms />}
        </div>
      </div>
    </MainLayout>
  );
};

export default PlantillasPage;
